export enum Elevation {
  Tooltip = 101,
  Strip = 1000,
  Header = 1020,
  ModalBackdrop = 1050,
  Popover = 2100,
  GlobalTooltip = 3000,
}
